import React, { useState } from "react";
import * as S from "../styles";

type Props = {
  dePara: Record<string, string>;
  onChange: (dePara: Record<string, string>) => void;
};

const DeParaSection: React.FC<Props> = ({ dePara, onChange }) => {
  const [novoOrigem, setNovoOrigem] = useState("");
  const [novoDestino, setNovoDestino] = useState("");
  const [editKey, setEditKey] = useState<string | null>(null);
  const [editOrigem, setEditOrigem] = useState("");
  const [editDestino, setEditDestino] = useState("");

  const entries = Object.entries(dePara);

  const handleAdd = (): void => {
    if (!novoOrigem.trim() || !novoDestino.trim()) return;
    onChange({ ...dePara, [novoOrigem.trim()]: novoDestino.trim() });
    setNovoOrigem("");
    setNovoDestino("");
  };

  const handleRemove = (key: string): void => {
    const updated = { ...dePara };
    delete updated[key];
    onChange(updated);
    if (editKey === key) setEditKey(null);
  };

  const handleStartEdit = (key: string, destino: string): void => {
    setEditKey(key);
    setEditOrigem(key);
    setEditDestino(destino);
  };

  const handleSaveEdit = (): void => {
    if (editKey === null || !editOrigem.trim() || !editDestino.trim()) return;
    const updated = { ...dePara };
    delete updated[editKey];
    updated[editOrigem.trim()] = editDestino.trim();
    onChange(updated);
    setEditKey(null);
  };

  const handleCancelEdit = (): void => {
    setEditKey(null);
  };

  return (
    <S.SectionCard>
      <S.SectionTitle>De-Para de Chaves</S.SectionTitle>
      <S.InfoBox>
        ℹ️ Renomeia campos no JSON antes do envio. Útil quando a prefeitura exige um nome de campo
        diferente do padrão. Ex: <code>servico[].cnae</code> → <code>servico[].codigoCnae</code>
      </S.InfoBox>

      {entries.length > 0 && (
        <S.Table>
          <thead>
            <tr>
              <th>Campo Original</th>
              <th>→</th>
              <th>Campo Destino</th>
              <th aria-label="Ações" />
            </tr>
          </thead>
          <tbody>
            {entries.map(([origem, destino]) => (
              editKey === origem ? (
                <tr key={`edit-${origem}`}>
                  <td><S.FormInput value={editOrigem} onChange={(e) => setEditOrigem(e.target.value)} style={{ minWidth: 100 }} /></td>
                  <td style={{ color: "#424242" }}>→</td>
                  <td><S.FormInput value={editDestino} onChange={(e) => setEditDestino(e.target.value)} style={{ minWidth: 100 }} /></td>
                  <td>
                    <S.IconButton type="button" onClick={handleSaveEdit}>✅</S.IconButton>
                    <S.IconButton type="button" onClick={handleCancelEdit}>❌</S.IconButton>
                  </td>
                </tr>
              ) : (
                <tr key={origem}>
                  <td><code>{origem}</code></td>
                  <td style={{ color: "#424242" }}>→</td>
                  <td><code>{destino}</code></td>
                  <td>
                    <S.IconButton type="button" onClick={() => handleStartEdit(origem, destino)}>✏️</S.IconButton>
                    <S.IconButton type="button" onClick={() => handleRemove(origem)}>🗑️</S.IconButton>
                  </td>
                </tr>
              )
            ))}
          </tbody>
        </S.Table>
      )}

      <S.FormRow>
        <S.FormInput
          placeholder="Campo original (ex: servico[].cnae)"
          value={novoOrigem}
          onChange={(e) => setNovoOrigem(e.target.value)}
        />
        <span style={{ color: "#424242" }}>→</span>
        <S.FormInput
          placeholder="Campo destino (ex: servico[].codigoCnae)"
          value={novoDestino}
          onChange={(e) => setNovoDestino(e.target.value)}
        />
        <S.SmallButton type="button" onClick={handleAdd}>+ Adicionar</S.SmallButton>
      </S.FormRow>
    </S.SectionCard>
  );
};

export default DeParaSection;
